import React from 'react'
import rolesConstants from '../constants/RolesConstants'
import lazy from './LazyWithRetry'
import CustomSvgIcon from '@/components/icons/builder/CustomSvgIcon'
import userIcon from '@/components/icons/builder/paths/userIcon'
import documentIcon from '@/components/icons/builder/paths/documentIcon'

/* Dash boards */
const DashboardMerchant = lazy(() => import('../../containers/pages/dashboard/components/DashboardMerchant.jsx'))
const DashboardEnterprise = lazy(() => import('../../containers/pages/dashboard/components/DashboardEnterprise.jsx'))

const CtmOpportunityList = lazy(() => import('../../containers/pages/customer/opportunity/CtmOpportunityList.jsx'))

const CtmProjectListTabs = lazy(() => import('../../containers/pages/customer/project/CtmProjectListTabs.jsx'))
const CtmProjectCancelationExternalListTabs = lazy(
  () => import('../../containers/pages/customer/project/cancellations/external/CtmProjectCancelationExternalListTabs'),
)

const CtmProjectDetails = lazy(() => import('../../containers/pages/customer/project/CtmProjectDetails.jsx'))

const CtmProjectCancelationDocumentalReviewWrapper = lazy(
  () =>
    import('../../containers/pages/customer/project/cancellations/documents/CtmProjectCancelationDocumentalReviewWrapper.jsx'),
)

const CtmProjectList = lazy(() => import('../../containers/pages/customer/project/CtmProjectList.jsx'))

const CtmProjectListCom = lazy(() => import('../../containers/pages/customer/project/CtmProjectListCom.jsx'))

const EntOpportunityList = lazy(() => import('../../containers/pages/enterprise/opportunity/EntOpportunityList.jsx'))

const EntProjectDetails = lazy(() => import('../../containers/pages/enterprise/project/EntProjectDetails.jsx'))

const EntAnalystDetails = lazy(
  () => import('../../containers/pages/dashboard/components/financeanalyst/EntAnalystDetails.jsx'),
)

const EntProjectList = lazy(() => import('../../containers/pages/enterprise/project/EntProjectList.jsx'))

const EntProjectListTabs = lazy(() => import('../../containers/pages/enterprise/project/EntProjectListTabs.jsx'))

const EntProjectMyProjectsTab = lazy(
  () => import('../../containers/pages/enterprise/project/project-list-tabs/EntProjectMyProjectsTab.jsx'),
)

const InsEnterpriseRegistration = lazy(
  () => import('../../containers/pages/insenterprise/InsEnterpriseRegistration.jsx'),
)

const LookerStudio = lazy(() => import('../../containers/pages/integrations/LookerStudio.jsx'))

const ScpQuotaList = lazy(() => import('../../containers/pages/customer/scpquotas/ScpQuotaList.jsx'))

const EntProjectListCom = lazy(() => import('../../containers/pages/enterprise/project/EntProjectListCom.jsx'))

const CtmOpportunityDetails = lazy(
  () => import('../../containers/pages/customer/opportunity/CtmOpportunityDetails.jsx'),
)

const PntAgentList = lazy(() => import('../../containers/pages/agent/PntAgentList.jsx'))
const PntAgentDetails = lazy(() => import('../../containers/pages/agent/PntAgentDetails.jsx'))

const InsMerchantList = lazy(() => import('../../containers/pages/merchant/InsMerchantList.jsx'))
const InsMerchantDetails = lazy(() => import('../../containers/pages/merchant/InsMerchantDetails.jsx'))

const EntRangeconfigList = lazy(() => import('../../containers/pages/entrangeconfig/EntRangeconfigList.jsx'))
const PntMaterialList = lazy(() => import('../../containers/pages/pntmaterial/PntMaterialList.jsx'))
const EntInsuranceConfigList = lazy(
  () => import('../../containers/pages/entinsuranceconfig/EntInsuranceConfigList.jsx'),
)
const ScpTrackerKOList = lazy(() => import('../../containers/pages/scptrackerko/ScpTrackerKOList.jsx'))

const InsEnterpriseList = lazy(() => import('../../containers/pages/insenterprise/InsEnterpriseList.jsx'))
const InsEnterpriseDetails = lazy(() => import('../../containers/pages/insenterprise/InsEnterpriseDetails.jsx'))
const AlertList = lazy(() => import('../../containers/pages/alert/PntAlertList.jsx'))
const Neocheck = lazy(() => import('../../containers/pages/integrations/Neocheck.jsx'))
const Sophia = lazy(() => import('../../containers/pages/integrations/Sophia.jsx'))

const OperatorTaskManager = lazy(
  () => import('../../containers/pages/dashboard/components/DashboardOperatorTaskManager.jsx'),
)

const OperatorMetrics = lazy(() => import('../../containers/pages/dashboard/components/operator/OperatorMetrics.jsx'))

const InsBureauList = lazy(() => import('../../containers/pages/bureau/InsBureauList.jsx'))

const CtmProjectCancelationInternalListTabs = lazy(
  () =>
    import('../../containers/pages/customer/project/cancellations/internal/CtmProjectCancelationInternalListTabs.jsx'),
)

const InsBureauHistory = lazy(() => import('../../containers/pages/bureau/InsBureauHistory.jsx'))

const Dashboard = lazy(() => import('../../containers/pages/dashboard/Dashboard.jsx'))

const DashboardAccountantPayments = lazy(() => import('../../containers/pages/dashboard/components/DashboardPayments'))

const CtmBillingRecord = lazy(() => import('../../containers/pages/customer/project/accountant/CtmBillingRecord'))

const EntBillingRecord = lazy(() => import('../../containers/pages/enterprise/project/accountant/EntBillingRecord'))

const DashboardAccountantBilling = lazy(
  () => import('../../containers/pages/dashboard/components/DashboardAccountantBilling'),
)
const DashboardAccountantReports = lazy(
  () => import('../../containers/pages/dashboard/components/DashboardAccountantReports.jsx'),
)

const DashboardFinanceAnalyst = lazy(
  () => import('../../containers/pages/dashboard/components/DashboardFinanceAnalyst.jsx'),
)

const DashboardCommercialCustomer = lazy(
  () => import('../../containers/pages/dashboard/components/DashboardCommercialCustomer.jsx'),
)

const DashboardCustomerArea = lazy(
  () => import('../../containers/pages/dashboard/components/DashboardCustomerArea.jsx'),
)

const DashboardCommercialEnterprise = lazy(
  () => import('../../containers/pages/dashboard/components/DashboardCommercialEnterprise.jsx'),
)

const ProjectListRiskTabs = lazy(() => import('../../containers/pages/risk/ProjectsListRiskTabs.jsx'))

const CtmBillingPaymentsLenderList = lazy(
  () => import('../../containers/pages/customer/project/billingpayment/ghf/CtmBillingPaymentsLenderList.jsx'),
)

const CtmBillingPaymentsMerchantList = lazy(
  () => import('../../containers/pages/customer/project/billingpayment/CtmBillingPaymentsMerchantList'),
)

const InsMerchantCalendar = lazy(() => import('../../containers/pages/merchant/InsMerchantCalendar'))

const PntSwapList = lazy(() => import('../../containers/pages/swap/PntSwapList.jsx'))

const ServiceDown = lazy(() => import('../../components/errors/ServiceDown'))

const Status = lazy(() => import('@/components/utils/StatusPage'))

import DescriptionIcon from '@mui/icons-material/Description'
import PersonSearchIcon from '@mui/icons-material/PersonSearch'
import NotificationsIcon from '@mui/icons-material/Notifications'
import DashboardIcon from '@mui/icons-material/Dashboard'
import CalculateIcon from '@mui/icons-material/Calculate'
import HomeIcon from '@mui/icons-material/Home'
import BureauIcon from '@/components/icons/BureauIcon'
import EuroIcon from '@mui/icons-material/Euro'
import CloseIcon from '@mui/icons-material/Close'
import FeedIcon from '@mui/icons-material/Feed'
import { CalendarMonth } from '@mui/icons-material'
import creditCardIcon from '@/components/icons/builder/paths/creditCardIcon'
const neocheck = '/assets/neocheck.png'
const simplai = '/assets/simplai.png'

export default [
  {
    component: Dashboard,
    path: ['/', '/home'],
    title: 'Dashboard',
    permission: [
      rolesConstants.ROLE_MERCHANT,
      rolesConstants.ROLE_MERCHANTCOM,
      rolesConstants.ROLE_MERCHANTADMIN,
      rolesConstants.ROLE_ADMIN,
      rolesConstants.ROLE_OPERATOR,
      rolesConstants.ROLE_COMMERCIAL,
      rolesConstants.ROLE_ACCOUNTANT,
      rolesConstants.ROLE_VIEWER,
      rolesConstants.ROLE_SUPERVISOR,
      rolesConstants.ROLE_FINANCEANALYST,
      rolesConstants.ROLE_LENDER,
      rolesConstants.ROLE_FINALCUSTOMER,
    ],
    menu: {
      acces: '/',
      label: 'NAV.DASHBOARD',
      icon: <HomeIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
    ],
  },
  {
    component: OperatorTaskManager,
    path: '/tasks',
    title: 'TaskManager',
    permission: [rolesConstants.ROLE_OPERATOR],
    menu: {
      acces: '/tasks',
      label: 'NAV.TASKS',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.TASKS',
        link: '/tasks',
      },
    ],
  },
  {
    component: OperatorMetrics,
    path: '/metrics',
    title: 'Metrics',
    permission: [rolesConstants.ROLE_OPERATOR],
    menu: {
      acces: '/metrics',
      label: 'NAV.METRICS',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.METRICS',
        link: '/metrics',
      },
    ],
  },
  {
    component: DashboardMerchant,
    path: '/customer',
    title: 'PanelMerchant',
    permission: [rolesConstants.ROLE_MERCHANT],
    menu: {
      acces: '/customer',
      label: 'NAV.PANEL',
      parent: 'CUSTOMER',
      icon: <DashboardIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.CUSTOMERS',
        link: '/customer',
      },
    ],
  },
  {
    component: DashboardEnterprise,
    path: '/enterprise',
    title: 'PanelEnterprise',
    permission: [rolesConstants.ROLE_MERCHANT, rolesConstants.ROLE_MERCHANTCOM],
    menu: {
      acces: '/enterprise',
      label: 'NAV.PANEL',
      parent: 'ENTERPRISE',
      icon: <DashboardIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ENTERPRISES',
        link: '/enterprise',
      },
    ],
  },
  {
    component: DashboardCommercialCustomer,
    path: '/customer',
    title: 'DashboardCommercialCtm',
    permission: [rolesConstants.ROLE_COMMERCIAL],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.CUSTOMERS',
        link: '/customer',
      },
    ],
  },
  {
    component: DashboardCommercialEnterprise,
    path: '/enterprise',
    title: 'DashboardCommercialEnt',
    permission: [rolesConstants.ROLE_COMMERCIAL],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ENTERPRISES',
        link: '/enterprise',
      },
    ],
  },
  {
    component: DashboardCustomerArea,
    path: '/customerarea',
    title: 'Área de cliente',
    permission: [rolesConstants.ROLE_FINALCUSTOMER],
  },
  {
    component: CtmOpportunityList,
    path: '/opportunities',
    title: 'Oportunidades',
    permission: [
      rolesConstants.ROLE_MERCHANT,
      rolesConstants.ROLE_MERCHANTCOM,
      rolesConstants.ROLE_OPERATOR,
      rolesConstants.ROLE_COMMERCIAL,
      rolesConstants.ROLE_VIEWER,
      rolesConstants.ROLE_SUPERVISOR,
    ],
    menu: {
      acces: '/opportunities',
      label: 'NAV.OPPORTUNITIES',
      parent: 'CUSTOMER',
      icon: <PersonSearchIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.CUSTOMERS',
        link: '/customer',
        roles: [rolesConstants.ROLE_MERCHANT, rolesConstants.ROLE_COMMERCIAL],
      },
      {
        label: 'NAV.OPPORTUNITIES',
        link: '/opportunities',
      },
    ],
  },
  {
    component: CtmProjectList,
    path: '/projects',
    title: 'Proyectos',
    permission: [rolesConstants.ROLE_OPERATOR, rolesConstants.ROLE_VIEWER, rolesConstants.ROLE_SUPERVISOR],
    menu: {
      acces: '/projects',
      label: 'NAV.PROJECTS',
      parent: 'CUSTOMER',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.PROJECTS',
        link: '/projects',
      },
    ],
  },
  {
    component: CtmProjectListTabs,
    path: '/projects',
    title: 'ProjectListTabs',
    permission: [rolesConstants.ROLE_MERCHANT, rolesConstants.ROLE_MERCHANTADMIN],
    menu: {
      acces: '/projects',
      label: 'NAV.PROJECTS',
      parent: 'CUSTOMER',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.CUSTOMERS',
        link: '/customer',
        roles: [rolesConstants.ROLE_MERCHANT],
      },
      {
        label: 'NAV.PROJECTS',
        link: '/projects',
      },
    ],
  },
  // Nemuru
  {
    path: 'https://app.nemuru.com/',
    title: 'Bancos',
    permission: [rolesConstants.ROLE_MERCHANT, rolesConstants.ROLE_MERCHANTCOM, rolesConstants.ROLE_MERCHANTADMIN],
    external: true,
    menu: {
      acces: 'https://app.nemuru.com/',
      label: 'NAV.BANKS',
      parent: 'CUSTOMER',
      icon: (
        <CustomSvgIcon svgString={creditCardIcon} width="1.5rem" height="1.5rem" style={{ marginLeft: '.20rem' }} />
      ),
    },
  },
  {
    component: CtmProjectListCom,
    path: '/projects',
    title: 'Proyectos Particulares',
    permission: [rolesConstants.ROLE_COMMERCIAL],
    menu: {
      acces: '/projects',
      label: 'NAV.PROJECTS',
      parent: 'CUSTOMER',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.CUSTOMERS',
        link: '/customer',
      },
      {
        label: 'NAV.PROJECTS',
        link: '/projects',
      },
    ],
  },
  {
    component: CtmProjectDetails,
    path: '/project/:idproject',
    title: 'CtmProjectDetails',
    permission: [
      rolesConstants.ROLE_MERCHANT,
      rolesConstants.ROLE_MERCHANTADMIN,
      rolesConstants.ROLE_OPERATOR,
      rolesConstants.ROLE_COMMERCIAL,
      rolesConstants.ROLE_VIEWER,
      rolesConstants.ROLE_SUPERVISOR,
      rolesConstants.ROLE_ACCOUNTANT,
    ],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.CUSTOMERS',
        link: '/customer',
        roles: [rolesConstants.ROLE_MERCHANT, rolesConstants.ROLE_COMMERCIAL],
      },
      {
        label: 'NAV.PROJECTS',
        link: '/projects',
        roles: [
          rolesConstants.ROLE_MERCHANT,
          rolesConstants.ROLE_MERCHANTADMIN,
          rolesConstants.ROLE_OPERATOR,
          rolesConstants.ROLE_COMMERCIAL,
          rolesConstants.ROLE_VIEWER,
          rolesConstants.ROLE_SUPERVISOR,
        ],
      },
      {
        label: 'NAV.PROJECT',
        link: '/project/:id',
      },
    ],
  },
  {
    component: CtmProjectCancelationDocumentalReviewWrapper,
    path: '/reviewDoc/:idproject',
    title: 'CtmProjectDocumentalValidation',
    permission: [rolesConstants.ROLE_OPERATOR, rolesConstants.ROLE_ACCOUNTANT],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.PAYMENTS',
        link: '/reviewDoc/:id',
      },
    ],
  },
  {
    component: EntOpportunityList,
    path: '/enterprise/opportunities',
    title: 'Oportunidades de Empresas',
    permission: [
      rolesConstants.ROLE_MERCHANT,
      rolesConstants.ROLE_MERCHANTCOM,
      rolesConstants.ROLE_OPERATOR,
      rolesConstants.ROLE_COMMERCIAL,
      rolesConstants.ROLE_VIEWER,
      rolesConstants.ROLE_SUPERVISOR,
    ],
    menu: {
      acces: '/enterprise/opportunities',
      label: 'NAV.OPPORTUNITIES',
      parent: 'ENTERPRISE',
      icon: <PersonSearchIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ENTERPRISES',
        link: '/enterprise',
        roles: [rolesConstants.ROLE_COMMERCIAL, rolesConstants.ROLE_MERCHANTCOM, rolesConstants.ROLE_MERCHANT],
      },
      {
        label: 'NAV.OPPORTUNITIES',
        link: '/enterprise/opportunities',
      },
    ],
  },
  {
    component: EntProjectDetails,
    path: '/enterprise/project/:idproject',
    title: 'EntProjectDetails',
    permission: [
      rolesConstants.ROLE_MERCHANT,
      rolesConstants.ROLE_MERCHANTCOM,
      rolesConstants.ROLE_MERCHANTADMIN,
      rolesConstants.ROLE_OPERATOR,
      rolesConstants.ROLE_COMMERCIAL,
      rolesConstants.ROLE_VIEWER,
      rolesConstants.ROLE_SUPERVISOR,
      rolesConstants.ROLE_FINANCEANALYST,
      rolesConstants.ROLE_ACCOUNTANT,
    ],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ENTERPRISES',
        link: '/enterprise',
        roles: [rolesConstants.ROLE_COMMERCIAL, rolesConstants.ROLE_MERCHANTCOM, rolesConstants.ROLE_MERCHANT],
      },
      {
        label: 'NAV.PROJECTS',
        link: '/enterprise/projects',
        roles: [
          rolesConstants.ROLE_MERCHANT,
          rolesConstants.ROLE_MERCHANTCOM,
          rolesConstants.ROLE_MERCHANTADMIN,
          rolesConstants.ROLE_OPERATOR,
          rolesConstants.ROLE_COMMERCIAL,
          rolesConstants.ROLE_VIEWER,
          rolesConstants.ROLE_SUPERVISOR,
          rolesConstants.ROLE_FINANCEANALYST,
        ],
      },
      {
        label: 'NAV.PROJECT',
        link: '/enterprise/project/:id',
      },
    ],
  },
  {
    component: EntAnalystDetails,
    path: '/entanalyst/:idanalyst',
    title: 'ProjectAnalystDetails',
    permission: [rolesConstants.ROLE_FINANCEANALYST],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ENTANALYST',
        link: '/entanalyst/:id',
      },
    ],
  },
  {
    component: EntProjectList,
    path: '/enterprise/projects',
    title: 'Proyectos Empresas',
    permission: [rolesConstants.ROLE_OPERATOR, rolesConstants.ROLE_VIEWER, rolesConstants.ROLE_SUPERVISOR],
    menu: {
      acces: '/enterprise/projects',
      label: 'NAV.PROJECTS',
      parent: 'ENTERPRISE',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.PROJECTS',
        link: '/enterprise/projects',
      },
    ],
  },
  {
    component: EntProjectListTabs,
    path: '/enterprise/projects',
    title: 'Proyectos Empresas',
    permission: [rolesConstants.ROLE_MERCHANT, rolesConstants.ROLE_MERCHANTADMIN],
    menu: {
      acces: '/enterprise/projects',
      label: 'NAV.PROJECTS',
      parent: 'ENTERPRISE',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ENTERPRISES',
        link: '/enterprise',
        roles: [rolesConstants.ROLE_MERCHANT],
      },
      {
        label: 'NAV.PROJECTS',
        link: '/enterprise/projects',
      },
    ],
  },
  {
    component: EntProjectMyProjectsTab,
    path: '/enterprise/projects',
    title: 'Proyectos Empresas',
    permission: [rolesConstants.ROLE_MERCHANTCOM],
    menu: {
      acces: '/enterprise/projects',
      label: 'NAV.PROJECTS',
      parent: 'ENTERPRISE',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },

      {
        label: 'NAV.ENTERPRISES',
        link: '/enterprise',
      },
      {
        label: 'NAV.PROJECTS',
        link: '/enterprise/projects',
      },
    ],
  },
  {
    component: EntProjectListCom,
    path: '/enterprise/projects',
    title: 'Proyectos Empresas',
    permission: [rolesConstants.ROLE_COMMERCIAL],
    menu: {
      acces: '/enterprise/projects',
      label: 'NAV.PROJECTS',
      parent: 'ENTERPRISE',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ENTERPRISES',
        link: '/enterprise',
      },
      {
        label: 'NAV.PROJECTS',
        link: '/enterprise/projects',
      },
    ],
  },
  {
    component: CtmOpportunityDetails,
    path: '/opportunity/:idopportunity',
    title: 'OpportunityDetails',
    permission: [
      rolesConstants.ROLE_MERCHANT,
      rolesConstants.ROLE_MERCHANTCOM,
      rolesConstants.ROLE_OPERATOR,
      rolesConstants.ROLE_COMMERCIAL,
      rolesConstants.ROLE_VIEWER,
      rolesConstants.ROLE_SUPERVISOR,
      rolesConstants.ROLE_ACCOUNTANT,
    ],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.CUSTOMERS',
        link: '/customer',
        roles: [rolesConstants.ROLE_MERCHANT, rolesConstants.ROLE_COMMERCIAL],
      },
      {
        label: 'NAV.OPPORTUNITIES',
        link: '/opportunities',
        roles: [
          rolesConstants.ROLE_MERCHANT,
          rolesConstants.ROLE_MERCHANTCOM,
          rolesConstants.ROLE_OPERATOR,
          rolesConstants.ROLE_COMMERCIAL,
          rolesConstants.ROLE_VIEWER,
          rolesConstants.ROLE_SUPERVISOR,
        ],
      },
      {
        label: 'NAV.OPPORTUNITY',
        link: '/opportunity/:id',
      },
    ],
  },
  {
    component: AlertList,
    path: '/alerts',
    title: 'Alertas',
    permission: [rolesConstants.ROLE_MERCHANT],
    menu: {
      acces: '/alerts',
      label: 'NAV.ALERTS',
      icon: <NotificationsIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ALERTS',
        link: '/alerts',
      },
    ],
  },
  {
    component: Neocheck,
    path: '/idvalidation',
    title: 'Neocheck',
    permission: [rolesConstants.ROLE_OPERATOR],
    menu: {
      acces: '/idvalidation',
      label: 'NAV.NEOCHECK',
      icon: <img style={{ width: '20px' }} src={neocheck} />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.NEOCHECK',
        link: '/idvalidation',
      },
    ],
  },
  {
    component: InsBureauList,
    path: '/bureau',
    title: 'Bureau',
    permission: [rolesConstants.ROLE_OPERATOR, rolesConstants.ROLE_COMMERCIAL, rolesConstants.ROLE_ACCOUNTANT],
    menu: {
      acces: '/bureau',
      label: 'NAV.BUREAU',
      parent: 'RISKS',
      icon: <BureauIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.BUREAU',
        link: '/bureau',
      },
    ],
  },
  {
    component: InsBureauHistory,
    path: '/bureau/history/:idbureau',
    title: 'bureau_history',
    permission: [rolesConstants.ROLE_OPERATOR, rolesConstants.ROLE_COMMERCIAL, rolesConstants.ROLE_ACCOUNTANT],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.BUREAU',
        link: '/bureau',
      },
      {
        label: 'NAV.BUREAU.HISTORY',
        link: '/bureau/history/:idbureau',
      },
    ],
  },
  {
    component: Sophia,
    path: '/scoring',
    title: 'Scoring',
    permission: [rolesConstants.ROLE_OPERATOR],
    menu: {
      acces: '/scoring',
      label: 'NAV.SOPHIA',
      parent: 'RISKS',
      icon: <img style={{ width: '20px' }} src={simplai} />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.SOPHIA',
        link: '/scoring',
      },
    ],
  },
  {
    component: ProjectListRiskTabs,
    path: '/risk',
    title: 'Proyectos Riesgo',
    permission: [rolesConstants.ROLE_OPERATOR, rolesConstants.ROLE_COMMERCIAL],
    menu: {
      acces: '/risk',
      label: 'NAV.RISKPROJECTS',
      parent: 'RISKS',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.RISKPROJECTS',
        link: '/risk',
      },
    ],
  },
  {
    component: PntAgentList,
    path: '/agents',
    title: 'Agents',
    permission: [rolesConstants.ROLE_ADMIN],
    menu: {
      acces: '/agents',
      label: 'NAV.AGENTS',
      icon: <CustomSvgIcon svgString={userIcon} width="1rem" height="1rem" style={{ marginLeft: '.20rem' }} />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.AGENTS',
        link: '/agents',
      },
    ],
  },
  {
    component: PntAgentDetails,
    path: '/agent/:idagent',
    title: 'AgentDetails',
    permission: [rolesConstants.ROLE_ADMIN],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.AGENTS',
        link: '/agents',
      },
      {
        label: 'NAV.AGENT',
        link: '/agent/:id',
      },
    ],
  },
  {
    component: InsEnterpriseList,
    path: '/insenterprises',
    title: 'Empresas Instaladores',
    permission: [rolesConstants.ROLE_ADMIN, rolesConstants.ROLE_COMMERCIAL, rolesConstants.ROLE_OPERATOR],
    menu: {
      acces: '/insenterprises',
      label: 'NAV.ENTERPRISES',
      parent: 'MANAGEMENT',
      icon: <PersonSearchIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ENTERPRISES',
        link: '/insenterprises',
      },
    ],
  },
  {
    component: InsEnterpriseDetails,
    path: '/insenterprise/:identerprise',
    title: 'InsEnterpriseDetails',
    permission: [rolesConstants.ROLE_ADMIN, rolesConstants.ROLE_COMMERCIAL, rolesConstants.ROLE_OPERATOR],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ENTERPRISES',
        link: '/insenterprises',
      },
      {
        label: 'NAV.ENTERPRISE',
        link: '/insenterprise/:id',
      },
    ],
  },
  {
    component: InsEnterpriseRegistration,
    path: '/insenterprise/registration',
    title: 'Alta de empresas',
    permission: [rolesConstants.ROLE_COMMERCIAL, rolesConstants.ROLE_ADMIN],
    menu: {
      acces: '/insenterprise/registration',
      label: 'NAV.INSENTERPRISE.REGISTRATION',
      parent: 'MANAGEMENT',
      icon: <PersonSearchIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.INSENTERPRISE.REGISTRATION',
        link: '/insenterprise/registration',
      },
    ],
  },
  {
    component: InsMerchantList,
    path: '/merchants',
    title: 'Instaladores',
    permission: [rolesConstants.ROLE_ADMIN, rolesConstants.ROLE_COMMERCIAL, rolesConstants.ROLE_OPERATOR],
    menu: {
      acces: '/merchants',
      label: 'NAV.USERS',
      parent: 'MANAGEMENT',
      icon: <DashboardIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.USERS',
        link: '/merchants',
      },
    ],
  },
  {
    component: InsMerchantDetails,
    path: '/merchant/:idmerchant',
    title: 'MerchantDetails',
    permission: [rolesConstants.ROLE_ADMIN, rolesConstants.ROLE_OPERATOR, rolesConstants.ROLE_COMMERCIAL],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.MERCHANTS',
        link: '/merchants',
      },
      {
        label: 'NAV.MERCHANT',
        link: '/merchant/:id',
      },
    ],
  },
  {
    component: EntRangeconfigList,
    path: '/entrangeconfig',
    title: 'Configuración Rangos O&M',
    permission: [rolesConstants.ROLE_ADMIN],
    menu: {
      acces: '/entrangeconfig',
      label: 'NAV.RANGECONFIG',
      parent: 'Z.ADMIN.CONFIG',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.RANGECONFIG',
        link: '/entrangeconfig',
      },
    ],
  },
  {
    component: PntMaterialList,
    path: '/pntmaterials',
    title: 'Configuración Materiales',
    permission: [rolesConstants.ROLE_ADMIN],
    menu: {
      acces: '/pntmaterials',
      label: 'NAV.MATERIALS',
      parent: 'Z.ADMIN.CONFIG',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.MATERIALS',
        link: '/pntmaterials',
      },
    ],
  },
  {
    component: EntInsuranceConfigList,
    path: '/entinsuranceconfig',
    title: 'Configuración de Seguros',
    permission: [rolesConstants.ROLE_ADMIN],
    menu: {
      acces: '/entinsuranceconfig',
      label: 'NAV.INSURANCECONFIG',
      parent: 'Z.ADMIN.CONFIG',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.INSURANCECONFIG',
        link: '/entinsuranceconfig',
      },
    ],
  },
  {
    component: ScpTrackerKOList,
    path: '/trackerko',
    title: 'Tracker KO',
    permission: [rolesConstants.ROLE_ADMIN],
    menu: {
      acces: '/trackerko',
      label: 'NAV.SCPTRACKERKO',
      parent: 'Z.ADMIN.CONFIG',
      icon: <DescriptionIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.SCPTRACKERKO',
        link: '/trackerko',
      },
    ],
  },
  {
    component: ServiceDown,
    path: '/servicedown',
    title: 'ServiceDown',
  },
  {
    component: Status,
    path: '/status',
    title: 'Status',
  },
  // Hablar con nel sobre: intentar unificar este y el siguiente, con una condición en "parent" para que aparezca en sitios diferentes según el rol
  {
    component: DashboardAccountantPayments,
    path: '/payments',
    title: 'Payments',
    permission: [rolesConstants.ROLE_OPERATOR, rolesConstants.ROLE_COMMERCIAL],
    menu: {
      acces: '/payments',
      label: 'NAV.ACCOUNTANTPAYMENTS',
      parent: 'CUSTOMER',
      icon: <EuroIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ACCOUNTANTPAYMENTS',
        link: '/payments',
      },
    ],
  },
  {
    component: DashboardAccountantPayments,
    path: '/payments',
    title: 'Payments',
    permission: [rolesConstants.ROLE_ACCOUNTANT],
    menu: {
      acces: '/payments',
      label: 'NAV.ACCOUNTANTPAYMENTS',
      parent: 'ACCOUNTANT',
      icon: <EuroIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ACCOUNTANTPAYMENTS',
        link: '/payments',
      },
    ],
  },
  {
    component: CtmBillingPaymentsLenderList,
    path: '/paymentslender',
    title: 'PaymentsLender',
    permission: [rolesConstants.ROLE_LENDER, rolesConstants.ROLE_ACCOUNTANT],
    menu: {
      acces: '/paymentslender',
      label: 'NAV.PAYMENTSGHF',
      parent: 'ACCOUNTANT',
      icon: <EuroIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.PAYMENTLENDER',
        link: '/paymentslender',
      },
    ],
  },
  {
    component: CtmBillingPaymentsMerchantList,
    path: '/merchantpayments',
    title: 'MerchantPayments',
    permission: [rolesConstants.ROLE_MERCHANT, rolesConstants.ROLE_MERCHANTADMIN],
    menu: {
      acces: '/merchantpayments',
      label: 'NAV.MERCHANTPAYMENTS',
      parent: 'MANAGE',
      icon: <EuroIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.MERCHANTPAYMENTS',
        link: '/merchantpayments',
      },
    ],
  },
  {
    component: CtmProjectCancelationExternalListTabs,
    path: '/projectcancel',
    title: 'ProjectCancellationListTabs',
    permission: [rolesConstants.ROLE_MERCHANT, rolesConstants.ROLE_MERCHANTADMIN],
    menu: {
      acces: '/projectcancel',
      label: 'NAV.CTM.CANCELLATIONS',
      parent: 'MANAGE',
      icon: <CloseIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.CTM.CANCELLATIONS',
        link: '/projectcancel',
      },
    ],
  },
  {
    component: InsMerchantCalendar,
    path: '/insCalendar',
    title: 'InsCalendar',
    permission: [rolesConstants.ROLE_MERCHANT, rolesConstants.ROLE_MERCHANTADMIN],
    menu: {
      acces: '/insCalendar',
      label: 'NAV.CALENDAR',
      parent: 'MANAGE',
      icon: <CalendarMonth />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.CALENDAR',
        link: '/insCalendar',
      },
    ],
  },
  {
    component: CtmBillingRecord,
    path: '/payments/ctmrecord/:idbillingpayment',
    title: 'CtmAccountantRecordNew',
    permission: [rolesConstants.ROLE_OPERATOR, rolesConstants.ROLE_ACCOUNTANT],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ACCOUNTANTPAYMENTS',
        link: '/payments',
      },
      {
        label: 'NAV.ACCOUNTANTRECORD',
        link: '/payments/ctmrecord/:id',
      },
    ],
  },
  {
    component: EntBillingRecord,
    path: '/payments/entrecord/:idbilling',
    title: 'EntAccountantRecord',
    permission: [rolesConstants.ROLE_ACCOUNTANT],
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.ACCOUNTANTPAYMENTS',
        link: '/payments',
      },
      {
        label: 'NAV.ACCOUNTANTRECORD',
        link: '/payments/entrecord/:id',
      },
    ],
  },
  {
    component: LookerStudio,
    path: '/lookerstudio',
    title: 'Looker Studio',
    permission: [rolesConstants.ROLE_COMMERCIAL],
    menu: {
      acces: '/lookerstudio',
      label: 'NAV.LOOKERSTUDIO',
      parent: 'ANALYTIC',
      icon: <DashboardIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.LOOKERSTUDIO',
        link: '/lookerstudio',
      },
    ],
  },
  {
    component: ScpQuotaList,
    path: '/scpquota',
    title: 'ScpQuotaList',
    permission: [rolesConstants.ROLE_OPERATOR],
    menu: {
      acces: '/scpquota',
      label: 'NAV.SCPQUOTAS',
      parent: 'MANAGEMENT',
      icon: <CustomSvgIcon svgString={documentIcon} width="1.2rem" height="1.2rem" style={{ marginLeft: '.20rem' }} />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.SCPQUOTAS',
        link: '/scpquota',
      },
    ],
  },
  {
    component: DashboardAccountantBilling,
    path: '/accountantbilling',
    title: 'Accountantbilling',
    permission: [rolesConstants.ROLE_ACCOUNTANT],
    menu: {
      acces: '/accountantbilling',
      label: 'NAV.ACCOUNTANTBILLINGS',
      parent: 'ACCOUNTANT',
      icon: <CalculateIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/accountant/accountantbilling',
      },
    ],
  },
  {
    component: DashboardAccountantReports,
    path: '/accountantreports',
    title: 'AccountantReports',
    permission: [rolesConstants.ROLE_ACCOUNTANT],
    menu: {
      acces: '/accountantreports',
      label: 'NAV.ACCOUNTANTREPORTS',
      parent: 'ACCOUNTANT',
      icon: <FeedIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/accountant/accountantreports',
      },
    ],
  },
  {
    component: CtmProjectCancelationInternalListTabs,
    path: '/projectcancel',
    title: 'ProjectCancellationListTabs',
    permission: [rolesConstants.ROLE_OPERATOR, rolesConstants.ROLE_ACCOUNTANT],
    menu: {
      acces: '/projectcancel',
      label: 'NAV.CTM.CANCELLATIONS',
      parent: 'MANAGEMENT',
      icon: <CloseIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.CTM.CANCELLATIONS',
        link: '/projectcancel',
      },
    ],
  },
  {
    component: DashboardFinanceAnalyst,
    path: '/financeanalyst',
    title: 'FinanceAnalyst',
    permission: [rolesConstants.ROLE_FINANCEANALYST],
    menu: {
      acces: '/financeanalyst',
      label: 'NAV.FINANCEANALYST',
      icon: <DashboardIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.FINANCEANALYST',
        link: '/',
      },
    ],
  },
  {
    component: PntSwapList,
    path: '/swap',
    title: 'SwapList',
    permission: [rolesConstants.ROLE_ACCOUNTANT],
    menu: {
      acces: '/swap',
      label: 'NAV.SWAP',
      icon: <FeedIcon />,
    },
    breadCrumb: [
      {
        label: 'NAV.DASHBOARD',
        link: '/',
      },
      {
        label: 'NAV.SWAP',
        link: '/swap',
      },
    ],
  },
]
